module.exports = __webpack_public_path__ + "img/p39.6e250660.png";